import React, { useEffect, useState } from "react";
import axios from "axios";
import AllDataHeader from "../../../Components/Reuseable/AllDataHeader";
import Rejected from "../../../assets/Icon/Rejected.png";
import AllModuleData from "../../../Components/Reuseable/AllModuleData";
import LoaderPost from "../../../Components/Reuseable/LoaderPost";

const RejectedFan = () => {
  const [event_data, setAllFanReject] = useState([]);
  const [buffer, setBuffer] = useState(true);
  useEffect(() => {
    axios.get("/api/star/fan/group/starlist/status").then((res) => {
      setBuffer(false);
      if (res.data.status === 200) {
        setAllFanReject(res.data.starRejected);
      }
    });
  }, []);

  return (
    <>
      <AllDataHeader
        title="Rejected Fan Group"
        image={Rejected}
        count={event_data.length}
      />
      {buffer ? (
        <LoaderPost />
      ) : (
        <AllModuleData
          data={event_data}
          urlLink={`fan-group-ignored/details`}
          fan={"true"}
        />
      )}
    </>
  );
};

export default RejectedFan;
